import clsx from 'clsx'
import React from 'react'

const AltLoginButton = ({ children, text, isSubmitting, onClick }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={clsx(
        'h-[34px] taller:h-[40px] text-sm taller:text-base text-black bg-white rounded-xl hover:bg-opacity-70 transition duration-100 active:shadow-[inset_0px_0px_14px_5px_#00000020] flex justify-center items-center',
        { 'pointer-events-none': isSubmitting }
      )}
    >
      {children}
      <p className="ml-2">{text}</p>
    </button>
  )
}

export default AltLoginButton
